import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { IndexFilter } from '../../../../services/properties/schema/IndexFilterSchema';

interface BillingConnectionFilterComponentProps {
    control: Control<IndexFilter>,
    errors: FieldErrors<IndexFilter>
}

const options = [
    { value: '', label: 'All' },
    { value: '1', label: 'Connected' },
    { value: '0', label: 'Not Connected' },
];

// Dev only (FilterComponent gates it): whether an active billing connection covers the property.
const BillingConnectionFilterComponent: React.FC<BillingConnectionFilterComponentProps> = ({ control, errors }) => {
    return (
        <div className='form-group'>
            <label className='form-label'>Billing Connection</label>
            <Controller
                control={control}
                name='billing_connected'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.billing_connected })}
                        options={options}
                        value={options.find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                        defaultValue={options[0]}
                    />
                )}
            />
            {errors.billing_connected && <div className="invalid-feedback">{errors.billing_connected.message}</div>}
        </div>
    )
}

export default BillingConnectionFilterComponent
